// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"SolidThumbUpBoardedRound_iconWrapper__Ka5a3","fade-in":"SolidThumbUpBoardedRound_fade-in__jW8gs"};